<template>
  <div style="width: 100%; padding-bottom: 10px" v-if="mode != 'view' || tdPenalizeDetail.mode == 'query'">
    <el-button type="primary" size="small" icon="el-icon-Check" @click="selectClick">选择</el-button>
  </div>
  <div style="width: 100%">
    <span v-if="mode == 'view'">{{ showLabel }}</span>
    <el-input v-else type="textarea" readonly v-model="showLabel" :rows="5" :maxlength="1000"
              show-word-limit></el-input>
  </div>
  <td-law-dialog-select
    :allowSelectLaw="allowSelectLaw"
    v-model="model.visibleSelect"
    v-model:data="model.selectRows"
    @change="selectSubmit"
    @changeLaw="changeLaw"
  ></td-law-dialog-select>
  <td-civil-code-law-dialog-select
    :allowSelectLaw="allowSelectLaw"
    v-model="model.visibleCivilCodeSelect"
    v-model:data="model.selectRows"
    @change="selectSubmit"
    @changeLaw="changeLaw">
  </td-civil-code-law-dialog-select>
</template>
<script setup>
import { computed, inject, reactive, ref } from 'vue'
import { CIVIL_ENV_CODE_DATE } from '../../../constants'
import dayjs from 'dayjs'

const props = defineProps({
  modelValue: {
    type: [Object, String, Number, Array],
    default: ''
  },
  mode: {
    type: String,
    default: 'add'
  },
  /**允许直接选择法律法规 */
  allowSelectLaw: {
    type: Boolean,
    default: false
  },
  caseDate: {
    type: String,
    default: ''
  }
})
const tdPenalizeDetail = inject('td-penalize-detail', { mode: '' })
const emit = defineEmits(['update:modelValue', 'update:visible', 'change', 'changeLaw'])
const formRef = ref(null)
const showLabel = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
const model = reactive({
  listQueryModel: {},
  selectRows: [],
  selectCaseLimitType: [], //限制选择的案件类型
  listData: [],
  dictData: [],
  visibleAdd: false,
  selectObj: [],
  defaultExpandedKeys: [],
  visibleSelect: false,
  visibleCivilCodeSelect: false,
  treeData: [],
  addData: {
    causeCategory: ''
  }
})

//显示选择弹框
const selectClick = () => {
  const civilEnvCodeDate = TdUI.getConfig(CIVIL_ENV_CODE_DATE)
  model.selectRows = []
  model.listQueryModel = {}
  if (civilEnvCodeDate && props.caseDate && dayjs(props.caseDate).isSameOrAfter(civilEnvCodeDate)) {
    model.visibleCivilCodeSelect = true
  } else {
    model.visibleSelect = true
  }

}

//选择保存
const selectSubmit = () => {
  emit('change', model.selectRows)
}
const changeLaw = data => {
  emit('changeLaw', data)
  model.visibleSelect = false
  model.visibleCivilCodeSelect = false
}

</script>
<script>
export default {
  name: 'PenalizeLawSelect',
  cname: '法律责任选择',
  viewDisplay: true
}
</script>
<style lang="scss">
.td-law-select {
  position: relative;
  height: 100%;

  .td-input-tree {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--el-border-color-base);

    .el-input {
      height: 30px;
    }

    .filter-tree {
      position: relative;
      flex: 1;
      overflow: auto;
    }
  }

  .is-error {
    .td-input-tree {
      border: 1px solid red;
    }
  }
}
</style>
